import {useEffect, useState} from "react";
import axios from "axios";

const MatchesDisplay = ({matches,setClickedUser}) => {
const [ matchedProfiles, setMatchedProfiles] = useState()

const matchedUserIds = matches.map(({userId})=>userId)

    const getMatches = async () =>{
        try{
            const response = await axios.get('https://match-app-backend.herokuapp.com/users',{
                params:{userIds:JSON.stringify(matchedUserIds)}
            })
            setMatchedProfiles(response.data)
            // console.log('matches',response.data)
        }catch(err){
            console.log(err)
        }
    }

    useEffect(()=>{
        getMatches()
    },[matches])
    useEffect(()=>{
        getMatches()
    },[])
    console.log('matches',matchedProfiles)
    return(
        <div className={'matches-display'}>
            {matchedProfiles?.map((match)=>(
                <div key={match?.user_id} className={'match-card'} onClick={()=>setClickedUser(match)}>
                    <div className={'img-container'}>
                        <img src={match?.url} alt={match?.first_name + " profile"}/>
                    </div>
                    <h3>{match?.first_name}</h3>
                </div>
            ))}
        </div>
    )
}
export default MatchesDisplay